import { render, staticRenderFns } from "./AffiliateContactPersonDialog.vue?vue&type=template&id=b5f129a8&"
import script from "./AffiliateContactPersonDialog.vue?vue&type=script&lang=js&"
export * from "./AffiliateContactPersonDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AffiliateContactPersonDialog.vue"
export default component.exports